import { isCategory, isFormat, isSubCategory } from '@eventbrite/categories';
import React from 'react';
import {
    CATEGORY_FILTER,
    FACETED_SEARCH_DROPDOWN_FILTER_PROP_MAP,
    FORMAT_FILTER,
    SEO_FRIENDLY_FILTERS,
    SUBCATEGORIES_FILTER,
} from '../../../../constants/filters';
import { getCanonicalSearchUrl } from '../../../../utils';

const seoFriendlyEventSearch = SEO_FRIENDLY_FILTERS.reduce(
    (memo: { [key: string]: string | string[] }, key: string) => {
        memo[key] = '';

        return memo;
    },
    {},
);

const removeUnlinkableValues = (
    values: { value: string; display?: string }[],
    filterType: string,
) =>
    values.filter(
        ({ value }) =>
            value &&
            ['custom_date', 'paid', 'clearPrice'].indexOf(value) === -1 &&
            (filterType !== CATEGORY_FILTER || isCategory(value)) &&
            (filterType !== FORMAT_FILTER || isFormat(value)) &&
            (filterType !== SUBCATEGORIES_FILTER || isSubCategory(value)),
    );

const FilterLinks = ({
    values,
    filterType,
    slug,
}: {
    values: { value: string; display?: string }[];
    filterType: string;
    slug: string;
}) => {
    const filteredValues = removeUnlinkableValues(values, filterType);
    const links = filteredValues.map(({ value, display }) => {
        let formattedEventSearch = seoFriendlyEventSearch;

        if (
            filterType === CATEGORY_FILTER ||
            filterType === FORMAT_FILTER ||
            filterType === SUBCATEGORIES_FILTER
        ) {
            formattedEventSearch = {
                ...seoFriendlyEventSearch,
                tags: [...(seoFriendlyEventSearch?.tags || []), value],
            };
        } else {
            formattedEventSearch = {
                ...seoFriendlyEventSearch,
                [filterType]: value,
            };
        }

        const path = getCanonicalSearchUrl({
            ...formattedEventSearch,
            slug,
        });

        return { href: path, display };
    });

    return (
        <ul>
            {links.map(({ href, display }) => (
                <li
                    key={href}
                    style={{ marginBottom: '8px', listStyle: 'none' }}
                >
                    <a href={href}>{display}</a>
                </li>
            ))}
        </ul>
    );
};

export const BotFilters = (props: { slug: string }) => (
    <section data-testid="bot-friendly-filters">
        {SEO_FRIENDLY_FILTERS.map((filterType) => {
            const heading =
                FACETED_SEARCH_DROPDOWN_FILTER_PROP_MAP[filterType].label;
            const values =
                FACETED_SEARCH_DROPDOWN_FILTER_PROP_MAP[filterType].values;

            return (
                <div
                    key={heading.toString()}
                    data-testid="bot-friendly-filter--heading"
                >
                    <section className="eds-text-bl">{heading}</section>
                    <FilterLinks
                        values={values}
                        filterType={filterType}
                        slug={props.slug}
                    />
                </div>
            );
        })}
    </section>
);

export default BotFilters;
